import Bjax from "@bilibili/bjax";

const host = "//api.bilibili.com";
const bjax = new Bjax({
  autoInjectDevice: true,
});
export const getUserInfo = () => bjax.get(`${host}/x/web-interface/nav`);
const origin = "//baselabs.bilibili.com";
const color = new URLSearchParams(location.search).get("x1-bilispy-color");
// 拉取列表
export const fetchNftList = ({
  item_id,
  page,
  pageSize,
  extra,
  active_id,
  mid: viewMid,
}) => {
  const url =
    active_id === 0
      ? `${origin}/x/gallery/nft/collect/list`
      : `${origin}/x/gallery/nft/collect/user/list`;
  const mid = active_id === 2 ? viewMid : 0;
  return new Promise((resolve, reject) => {
    bjax
      .get(
        url,
        {
          ps: pageSize,
          pn: page,
          item_id,
          mid,
        },
        color
          ? {
            headers: {
              "x1-bilispy-color": color,
            },
          }
          : {}
      )
      .then(async (res) => {
        if (res.code) {
          reject(res);
        }
        // res.data.total = 98; // 测试分页功能
        const img_info = {
          width: 200,
          height: 200,
        };
        if (res.data.nft_list && !extra) {
          try {
            const info = await bjax.get(
              res.data.nft_list[0].image.replace(/^https?:/, "") + "@info",
              {},
              {
                auth: "web",
                noTsParams: true,
                csrfKey: "",
                withCredentials: false,
              }
            );
            img_info.height = (info.height / info.width) * 200;
          } catch (error) {
            console.error(error);
          }
        }
        let result = res.data.nft_list ?? [];
        resolve({
          result,
          total: res.data.total,
          no_more: result.length < pageSize,
          extra: extra || {
            item_name: res.data.item_name,
            img_info,
            private: res.data.private,
          },
        });
      })
      .catch(reject);
  });
};
// 更新点赞
export const updateLikeState = ({ nft_id, action }) => {
  const url = `${origin}/x/gallery/nft/like`;
  return bjax.post(url, {
    nft_id,
    from: "nft_list",
    action,
  });
};
